<template>
  <div class="w-screen h-screen">
    <!-- <div id="ChappMap" class="h-full w-full"></div> -->

    <l-map
      ref="map"
      @ready="onReady()"
      class="h-full w-full z-0"
      :zoom="zoom"
      :maxZoom="maxZoom"
      :center="center"
      :options="{ zoomControl: true , tap:false}"
    >
      <l-tile-layer :url="urlBasemap" :attribution="attribution"></l-tile-layer>
    </l-map>

    <div
      class="flex flex-wrap w-auto absolute z-11 rounded-md max-h-full top-0 right-0 mt-3 mr-4 mb-0"
    >
      <!-- <div class="w-1/3">
        <button
          @click="showingMultimediaGallery = true"
          class="bg-secondary-color hover:bg-white px-4 py-3 mx-4 shadow-lg font-bold text-white hover:text-secondary-color-dark hover:border-primary-color"
        >
          Galería
        </button>
      </div> -->
      <!-- <div class="w-2/3">
        <button
          @click="checkSearchResults()"
          class="bg-secondary-color hover:bg-white px-4 py-3 shadow-lg font-bold text-white hover:text-secondary-color-dark hover:border-primary-color"
        >
          Solicitar descarga
        </button>
      </div> -->
    </div>
    <div
      class="w-auto absolute z-10 rounded-md max-h-full bottom-0 mb-5 ml-5 bg-white px-4 py-3 shadow-lg"
    >
      <div class="flex flex-col text-left font-semibold tracking-wider">
        <div class="flex items-center pb-2">
          <img class="h-10 w-10" src="/../imgs/pin_biocultural.png" />
          <span style="color: #70ac48" class="text-base mb-1"
            >Ficha de proyecto: {{ globalCountBiocultural }}</span
          >
        </div>
        <hr />
        <span class="mt-1">Total: {{ globalcountTotal }}</span>
      </div>
    </div>

    <!-- <div
      class="flex flex-col w-5/12 absolute top-0 left-0 mt-5 ml-5"
      style="margin-left: 60px"
    >
      <div class="flex w-full">
        <div class="flex w-full relative">
          <input
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            v-model="searchValue"
            @input="filterLevantamientos()"
          />
          <div class="flex absolute top-0 right-0 h-full">
            <button
              v-if="searchValue !== ''"
              class="flex items-center justify-center bg-red-500 text-white w-12"
              @click="clearFilterLevantamientos()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
              >
                <path
                  d="M8.4 17 12 13.4 15.6 17 17 15.6 13.4 12 17 8.4 15.6 7 12 10.6 8.4 7 7 8.4 10.6 12 7 15.6ZM12 22Q9.925 22 8.1 21.212Q6.275 20.425 4.925 19.075Q3.575 17.725 2.788 15.9Q2 14.075 2 12Q2 9.925 2.788 8.1Q3.575 6.275 4.925 4.925Q6.275 3.575 8.1 2.787Q9.925 2 12 2Q14.075 2 15.9 2.787Q17.725 3.575 19.075 4.925Q20.425 6.275 21.212 8.1Q22 9.925 22 12Q22 14.075 21.212 15.9Q20.425 17.725 19.075 19.075Q17.725 20.425 15.9 21.212Q14.075 22 12 22ZM12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12ZM12 20Q15.325 20 17.663 17.663Q20 15.325 20 12Q20 8.675 17.663 6.337Q15.325 4 12 4Q8.675 4 6.338 6.337Q4 8.675 4 12Q4 15.325 6.338 17.663Q8.675 20 12 20Z"
                />
              </svg>
            </button>
            <span
              class="flex items-center justify-center rounded-r bg-purple-500 text-white w-12 h-full"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 fill-current"
              >
                <path
                  d="M19.6 21 13.3 14.7Q12.55 15.3 11.575 15.65Q10.6 16 9.5 16Q6.775 16 4.888 14.113Q3 12.225 3 9.5Q3 6.775 4.888 4.887Q6.775 3 9.5 3Q12.225 3 14.113 4.887Q16 6.775 16 9.5Q16 10.6 15.65 11.575Q15.3 12.55 14.7 13.3L21 19.6ZM9.5 14Q11.375 14 12.688 12.688Q14 11.375 14 9.5Q14 7.625 12.688 6.312Q11.375 5 9.5 5Q7.625 5 6.312 6.312Q5 7.625 5 9.5Q5 11.375 6.312 12.688Q7.625 14 9.5 14Z"
                />
              </svg>
            </span>
          </div>
        </div>

        <button
          :class="[showFilters ? 'bg-red-500' : 'bg-blue-500']"
          class="flex items-center justify-center text-white w-12 rounded ml-2"
          @click="showFilters = !showFilters"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current">
            <path
              d="M14 13V19Q14 19.425 13.713 19.712Q13.425 20 13 20H11Q10.575 20 10.288 19.712Q10 19.425 10 19V13L4.2 5.6Q3.825 5.1 4.088 4.55Q4.35 4 5 4H19Q19.65 4 19.913 4.55Q20.175 5.1 19.8 5.6ZM12 12.3 16.95 6H7.05ZM12 12.3Z"
            />
          </svg>
        </button>
      </div>

      <div class="flex mt-2" v-show="!showFilters">
        <span
          class="flex items-center text-xs bg-blue-500 px-2 py-1 rounded-full text-white font-bold cursor-default select-none"
          v-if="filterByProject"
          >Por proyecto
          <span
            class="ml-2 cursor-pointer"
            @click="
              filterByProject = false;
              filterLevantamientos();
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 fill-current"
            >
              <path
                d="M8.4 17 12 13.4 15.6 17 17 15.6 13.4 12 17 8.4 15.6 7 12 10.6 8.4 7 7 8.4 10.6 12 7 15.6ZM12 22Q9.925 22 8.1 21.212Q6.275 20.425 4.925 19.075Q3.575 17.725 2.788 15.9Q2 14.075 2 12Q2 9.925 2.788 8.1Q3.575 6.275 4.925 4.925Q6.275 3.575 8.1 2.787Q9.925 2 12 2Q14.075 2 15.9 2.787Q17.725 3.575 19.075 4.925Q20.425 6.275 21.212 8.1Q22 9.925 22 12Q22 14.075 21.212 15.9Q20.425 17.725 19.075 19.075Q17.725 20.425 15.9 21.212Q14.075 22 12 22ZM12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12Q12 12 12 12ZM12 20Q15.325 20 17.663 17.663Q20 15.325 20 12Q20 8.675 17.663 6.337Q15.325 4 12 4Q8.675 4 6.338 6.337Q4 8.675 4 12Q4 15.325 6.338 17.663Q8.675 20 12 20Z"
              />
            </svg>
          </span>
        </span>
      </div>

      <div class="w-2/3 bg-white mt-2 rounded p-2" v-show="showFilters">
        <div class="w-full px-3 mb-6 md:mb-0">
          <label
            class="uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left flex items-center"
            for="project"
            >Por proyecto
            <input
              class="ml-2"
              type="checkbox"
              v-model="filterByProject"
              @change="filterLevantamientos('byProject')"
            />
          </label>

          <div class="relative" v-show="filterByProject">
            <select
              v-model="projectSelected"
              name="project"
              class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              @change="filterLevantamientos()"
            >
              <option disabled selected value="null">
                Seleccione un proyecto
              </option>
              <template v-for="project in projects">
                <option :key="'projLev' + project.id" :value="project.id">
                  {{ project.nombre }}
                </option>
              </template>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>

          <button
            v-show="filterByProject && projectSelected != null"
            v-on:click="showProjectDetailModal()"
            class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-1 px-4 mx-1 mt-0 border border-secondary-color-dark hover:border-transparent rounded"
          >
            ver proyecto
          </button>

          <div class="relative" v-show="filterByType">
            <select
              v-model="typeSelected"
              name="type"
              class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 mb-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              @change="filterLevantamientos()"
            >
              <option disabled selected value="null">
                Seleccione un tipo de ficha
              </option>
              <template v-for="type in types">
                <option :key="'typeLev' + type.id" :value="type.id">
                  {{ type.nombre }}
                </option>
              </template>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div
      v-if="levantamientosHide.length > 0"
      class="flex flex-col-reverse w-1/4 absolute bottom-0 right-0 mb-5 mr-5 select-none"
    >
      <div
        class="flex items-center justify-between w-full bg-white rounded-md shadow-lg px-4 py-2 cursor-pointer mt-2"
        @click="showHiddenLev = !showHiddenLev"
      >
        <span class="text-sm font-semibold tracking-wider"
          >Levantamientos privados ({{ levantamientosHide.length }})</span
        >
        <span class="ml-2" v-if="!showHiddenLev">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current">
            <path d="M7.4 15.4 6 14l6-6 6 6-1.4 1.4-4.6-4.6Z" />
          </svg>
        </span>

        <span class="ml-2" v-else>
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current">
            <path d="m12 15.4-6-6L7.4 8l4.6 4.6L16.6 8 18 9.4Z" />
          </svg>
        </span>
      </div>

      <div v-if="showHiddenLev" class="overflow-auto" style="max-height: 35vh">
        <div
          v-for="hiddenLev in levantamientosHide"
          :key="hiddenLev.id"
          class="flex w-full justify-between items-center bg-white rounded-md shadow-lg mb-2 px-4 py-2"
        >
          <div class="flex flex-col text-left">
            <span class="text-purple-700">{{ hiddenLev.nombre }}</span>
            <span class="text-xs" :style="'color:' + hiddenLev.cat_color">{{
              hiddenLev.cat_principal
            }}</span>
          </div>
          <div class="flex flex-col">
            <button
              class="bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center text-xs rounded-lg text-gray-100 tracking-wide mb-2"
              type="button"
              @click="
                selectedHiddenLevInfo = hiddenLev;
                showHiddenFichaModal = true;
              "
            >
              Ver ficha
            </button>
          </div>
        </div>
      </div>
    </div>

    <ficha-modal
      :showing="showFichaModal"
      :levantamientoInfo="selectedLevantamientoInfo"
      @close="closeFichaModal()"
    ></ficha-modal>

    <ficha-modal
      :showing="showHiddenFichaModal"
      :levantamientoInfo="selectedHiddenLevInfo"
      @close="showHiddenFichaModal = false"
    ></ficha-modal>

    <compartir-shared
      :showing="showShared"
      :levantamientoInfo="selectedLevantamientoInfo"
      @close="showShared = false"
    ></compartir-shared>

    <!--     <project-detail-modal
      :showing="showProjectDetail"
      @close="showProjectDetail = false"
    ></project-detail-modal>    -->

    <levantamiento-project-modal
      :showing="showProjectDetail"
      :projectId="projectSelected"
      @close="showProjectDetail = false"
    ></levantamiento-project-modal>

    <zip-name-modal :showing="askingForNameOfFile">
      <form class="w-full" id="formDataDownload" @submit.prevent>
        <div class="justify-center">
          <div class="uppercase text-gray-900">
            Introduce los datos del archivo a generar
          </div>
          <div style="font-size: 12px; font-weight: bold; color: #fe0615">
            Se generará un archivo .zip con la información de los registros
            actualmente visibles en el mapa, si desea registros específicos
            puede filtrarlos en el buscador
          </div>
        </div>
        <div class="w-full mt-4">
          <span
            class="block uppercase font-bold text-xs text-gray-900 text-left"
            >NOMBRE de la descarga</span
          >
          <input
            type="text"
            id="nameFileToExport"
            class="w-full appearance-none border rounded py-2 px-3 mt-1 mb-1 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
          />
          <p v-if="this.errors.namefile" class="text-red-500 text-xs italic">
            Ingrese un nombre
          </p>
          <span
            class="block mt-3 uppercase font-bold text-xs text-gray-900 text-left"
            >DESCRIPCIÓN / USO DE INFORMACIÓN</span
          >
          <span
            class="block text-xs text-gray-900 text-left"
            style="font-size: 12px; align-text: left"
            >(Indique qué información está solicitando para descarga y para qué
            se utlizará, esto ayudará al revisor a autorizar su descarga)</span
          >
          <textarea
            type="text"
            id="descriptionFileToExport"
            class="w-full appearance-none border rounded py-2 px-3 mt-1 mb-1 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
          />
          <p
            v-if="this.errors.descriptionfile"
            class="text-red-500 text-xs italic"
          >
            Ingrese una descripción
          </p>
        </div>

        <span
          class="block text-xs text-gray-900 text-left"
          style="font-size: 12px; align-text: center"
          >La descarga se realizará previa autorización, cuando el revisor
          apruebe su solicitud de descarga, podrá acceder a ésta en la sección
          "<b>Mis descargas</b>"</span
        >

        <div class="w-full">
          <button
            class="mt-4 mx-1 px-4 py-2 rounded-lg text-gray-100 text-center font-bold tracking-wider bg-secondary-color hover:bg-secondary-color-dark"
            @click="exportLevantamientos()"
          >
            Solicitar
          </button>
          <button
            class="mt-4 mx-1 px-4 py-2 rounded-lg text-gray-100 text-center font-bold tracking-wider bg-red-500 hover_bg-danger-color"
            @click="closeModalToDownloads()"
          >
            Cancelar
          </button>
        </div>
      </form>
    </zip-name-modal>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Solicitud de descarga enviada</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="msgUnapprovedRecords">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">No hay registros aprobados</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="msgUnapprovedRecords = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="msgNoRecordsToExport">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          No hay registros para descargar
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="msgNoRecordsToExport = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <multimedia-modal
      :showing="showingMultimedia"
      :multimedia="currentMultimedia"
      @close="showingMultimedia = false"
    ></multimedia-modal>

    <multimedia-gallery-modal
      :showing="showingMultimediaGallery"
      @close="showingMultimediaGallery = false"
      :multimedia="listGalleryMultimedia"
      @zoom="zoomOnMap"
    ></multimedia-gallery-modal>

    <div id="img-2"></div>
  </div>
</template>

<script>
import L from "leaflet";
import { LMap, LGeoJson, LTileLayer } from "vue2-leaflet";
import Vue2LeafletMarkercluster from "vue2-leaflet-markercluster";
import "leaflet.heat";
import "leaflet-geometryutil";
import EventBus from "../event-bus";
import FichaModal from "./FichaModal";
import CompartirShared from "./CompartirShared";

import buttons from "./Buttons";
import axios from "axios";
//import polygon from "../assets/polygonChapp.json";
import * as turf from "@turf/turf";
import * as chartjs from "chart.js";
import ZIPNameModal from "./ZIPNameModal";
import AlertDialog from "./AlertDialog";
import MultimediaModal from "./MultimediaModal";
//import ProjectDetailModal from "./ProjectDetailModal.vue";
import LevantamientoProjectModal from "./LevantamientoProjectModal";
import MultimediaGalleryModal from "./MultimediaGalleryModal.vue";

// Nombre de días...
var weekday = new Array(7);
weekday[0] = "Dom";
weekday[1] = "Lun";
weekday[2] = "Mar";
weekday[3] = "Mie";
weekday[4] = "Jue";
weekday[5] = "Vie";
weekday[6] = "Sáb";

// Nombres de meses...
var month = new Array();
month[0] = "Ene";
month[1] = "Feb";
month[2] = "Mar";
month[3] = "Abr";
month[4] = "May";
month[5] = "Jun";
month[6] = "Jul";
month[7] = "Ago";
month[8] = "Sep";
month[9] = "Oct";
month[10] = "Nov";
month[11] = "Dic";

export default {
  name: "Map",
  data: function () {
    return {
      id: null,
      updateCluster: true,
      zoom: 9,
      maxZoom: 18,
      //center: [19.412257, -99.200871],
      center: [20.58651, -89.01501],
      map: null,
      //heat: null,
      valor: { selectmap: "traffic" },
      /* complaints: false, */
      /*   heatMapcomplaints: false,
      users: false,
      authorities: false, */
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      /* complaintsList: [], */
      clusterOptions: { disableClusteringAtZoom: 11 },
      latLngArray: [],

      /*       geojsonVisitor: [],
      geojsonAuthorities: [], */
      //geojsonChappultepec: polygon,
      visitorMarker: "../apidev/img/visit-marker.png",
      authorityMarker: "../apidev/img/authority-marker.png",

      globalCountMaterial: 0,
      globalCountInmaterial: 0,
      globalCountNatural: 0,
      globalCountBiocultural: 0,
      globalcountTotal: 0,

      levantamientos: null,
      markers: null,
      markerCluster: null,

      showFichaModal: false,
      selectedLevantamientoInfo: {},
      urlBasemap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      searchValue: "",
      backupLayers: null,
      currentMediaIndex: 0,
      askingForNameOfFile: false,
      fileNameToExport: null,
      filteredLevantamientos: [],
      showingSuccess: false,
      showingError: false,
      msgUnapprovedRecords: false,
      msgNoRecordsToExport: false,
      showFilters: false,
      filterByProject: false,
      filterByType: false,
      projects: [],
      projectSelected: null,
      types: [], //tipos de fichas: material, inmaterial, de proyecto
      typeSelected: null,
      errors: {
        namefile: false,
        descriptionfile: false,
      },
      levantamientosHide: [],
      showHiddenLev: false,
      selectedHiddenLevInfo: {},
      showHiddenFichaModal: false,
      showingMultimedia: false,
      showingMultimediaGallery: false,
      listGalleryMultimedia: [],
      currentMultimedia: {},
      showProjectDetail: false,
      topUsers: [],
      showTopUsers: false,
      email: localStorage.getItem("email"),
      category: window.atob(localStorage.getItem("category")),
      showShared: false,
    };
  },
  components: {
    LMap,
    LTileLayer,
    LGeoJson,
    buttons,
    "v-marker-cluster": Vue2LeafletMarkercluster,
    FichaModal,
    "zip-name-modal": ZIPNameModal,
    AlertDialog,
    MultimediaModal,
    //ProjectDetailModal,
    LevantamientoProjectModal,
    MultimediaGalleryModal,
    CompartirShared,
  },
  mounted() {
    if (this.$route.params.id) {
      // removed console log
      let id = this.$route.params.id;
      this.id = id;
      this.getLevantamientos();
      this.fetchProjects();
      this.fetchTypes();
      this.getTopUsers();
    }
  },
  // activated() {
  //   //this.getComplaints();
  //   EventBus.$emit("updateNotification", {});
  //   // removed console log
  // },
  // deactivated() {
  //   this.searchValue = "";
  //   this.backupLayers = null;
  // },
  watch: {
    "valor.selectmap": function (val) {
      if (val === "traffic") {
        this.urlBasemap = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
        this.attribution =
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
      } else {
        this.urlBasemap =
          "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
        this.attribution =
          "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community";
      }
    },
    complaints: function (val) {
      //Code for complaints button
    },
    heatMapcomplaints: function (val) {
      //code
    },
    users: function (val) {
      //code
    },
    authorities: function (val) {
      //code
    },
  },

  methods: {
    onReady() {
      this.map = this.$refs.map.mapObject;
    },
    imgmap: function (click) {
      if (click.mapa == "traffic") {
        this.valor.selectmap = click.mapa;
      } else if (click.mapa == "satellite") {
        this.valor.selectmap = click.mapa;
      }
    },
    getLevantamientos: function () {
      // removed console log
      let that = this;

      this.globalCountMaterial = 0;
      this.globalCountInmaterial = 0;
      this.globalCountNatural = 0;
      this.globalCountBiocultural = 0;
      this.globalcountTotal = 0;

      var icon_url = "pin_azul";

      axios
        .post(
          "../apidev/levantamientos/levantamientosdeUsuario",
          {
            select_user_id: this.id,
            category: this.category,
            email: this.email,
            user_id: localStorage.getItem("user_id"),
          },
          this.config
        )
        .then((response) => {
          //// removed console log
          let listaLevantamientos = response.data.levantamientos;
          this.levantamientos = listaLevantamientos.filter(
            (levantamiento) => !levantamiento.ubicacion_sensible
          );

          this.levantamientosHide = listaLevantamientos.filter(
            (levantamiento) => levantamiento.ubicacion_sensible
          );

          listaLevantamientos.forEach((levantamiento) => {
            if (levantamiento.media_array !== null) {
              let multimediaArray = JSON.parse(levantamiento.media_array);
              multimediaArray.forEach((multimedia) => {
                //if (multimediaArray.length > 0) {
                multimedia.nombre = levantamiento.nombre;
                multimedia.nombre_usuario = levantamiento.nombre_usuario;
                multimedia.apellido_usuario = levantamiento.apellido_usuario;
                var TDate = new Date(levantamiento.fecha_levantamiento);
                TDate =
                  weekday[TDate.getDay()] +
                  " " +
                  TDate.getDate() +
                  " de " +
                  month[TDate.getMonth()] +
                  " de " +
                  TDate.getFullYear();
                multimedia.TDate = TDate;
                multimedia.id = levantamiento.id;
                multimedia.latitud = levantamiento.latitud;
                multimedia.longitud = levantamiento.longitud;
                this.listGalleryMultimedia.push(multimedia);
                //}
              });
            }
          });

          if (this.markerCluster && this.map.hasLayer(this.markerCluster)) {
            // removed console log
            this.markerCluster.clearLayers();
          } else {
            this.markerCluster = L.markerClusterGroup({
              spiderfyOnMaxZoom: true,
              chunkedLoading: true,
              chunkInterval: 0,
              showCoverageOnHover: true,
              zoomToBoundsOnClick: true,
              animate: true,
              animateAddingMarkers: true,
              iconCreateFunction: function (cluster) {
                return that.createClusterIcon(cluster);
              },
            });
            //}).on('clusterclick',openClusterPopUp,markerClusterWS);
            this.map.addLayer(this.markerCluster);
          }

          this.levantamientos.forEach((levantamiento) => {
            try {
              switch (levantamiento.cat_principal) {
                case "Patrimonio material":
                  icon_url = "../imgs/pin_material.png";
                  break;
                case "Patrimonio inmaterial":
                  icon_url = "../imgs/pin_inmaterial.png";
                  break;
                case "Patrimonio natural":
                  icon_url = "../imgs/pin_natural.png";
                  break;
                case "Ficha de proyecto":
                  icon_url = "../imgs/pin_biocultural.png";
                  break;
              }
            } catch (err) {
              // removed console log
              icon_url = "../imgs/pin_azul.png";
            }

            var levantmientoIcon = L.icon({
              iconUrl: icon_url,
              iconSize: [30, 30], // size of the icon
            });

            if (
              levantamiento.latitud != null &&
              levantamiento.longitud != null
            ) {
              var markerLevantamiento = L.marker(
                [levantamiento.latitud, levantamiento.longitud],
                {
                  info: levantamiento,
                  icon: levantmientoIcon,
                }
              ).on("click", function (e) {
                // removed console log
                // removed console log
                that.selectedLevantamientoInfo = levantamiento;

                that.currentMediaIndex = 0;

                //hasta que se muestre la imagen la hace 'zoomable'
                let interval = setInterval(function () {
                  let elementImage = document.querySelector("#mediaPopup");
                  if (elementImage != null) {
                    clearInterval(interval);
                    zoomer();
                  }
                }, 100);
              });

              // Formateamos la fecha...
              var TDate = new Date(levantamiento.fecha_levantamiento);
              TDate =
                weekday[TDate.getDay()] +
                " " +
                TDate.getDate() +
                " de " +
                month[TDate.getMonth()] +
                " de " +
                TDate.getFullYear() +
                "<br>" +
                this.pad(TDate.getHours(), 2) +
                ":" +
                this.pad(TDate.getMinutes(), 2) +
                " hrs.";

              let levantamientoOrientation = "vertical";
              let popupWidth = "396px";
              let imageWidthPopup = "300px";
              if (levantamiento.media_metadata) {
                levantamientoOrientation =
                  levantamiento.media_metadata.imageWidth >
                  levantamiento.media_metadata.imageHeight
                    ? "horizontal"
                    : "vertical";
                imageWidthPopup =
                  levantamientoOrientation === "horizontal" ? "500px" : "300px";
                popupWidth =
                  levantamientoOrientation === "horizontal" ? "596px" : "396px";
              }

              let popuphtml = "";

              popuphtml += `
                <div style="width: ${popupWidth};">
                  <div class="flex flex-col text-center">
                    <span style='color:darkblue; font-size: 18px;'>
                      ${levantamiento.nombre}
                    </span>
                    <span style="color:${levantamiento.cat_color}; font-size: 12px;">
                      ${levantamiento.cat_principal}
                    </span>
                  </div>`;

              if (levantamiento.media_array !== null) {
                popuphtml += `
                  <div class="flex overflow-hidden items-center">
                `;
                let multimediaArray = JSON.parse(levantamiento.media_array);
                if (multimediaArray.length > 0) {
                  let firstMedia = multimediaArray[0];

                  if (firstMedia.mimeType.includes("image")) {
                    let flexSize =
                      imageWidthPopup === "500px" ? "596px" : "396px";

                    if (multimediaArray.length > 1) {
                      popuphtml += `
                      <span class="flex items-center justify-center bg-gray-900 bg-opacity-50 text-white cursor-pointer" onclick="slideToLeft();">
                        <svg xmlns="http://www.w3.org/2000/svg" class="fill-current" height="48" width="48">
                          <path d="M28.05 36 16 23.95 28.05 11.9 30.2 14.05 20.3 23.95 30.2 33.85Z"/>
                        </svg>
                      </span>
                    `;

                      if (imageWidthPopup === "500px") {
                        flexSize = "500px";
                      } else {
                        flexSize = "300px";
                      }
                    }

                    popuphtml += `
                      <div class="flex items-center justify-center select-none" style="flex: 0 0 ${flexSize};">
                        <div id="img-zoomer-box">
                          <img id="mediaPopup" class="CImg" style="max-width: ${imageWidthPopup}; max-height: 300px; margin-top: 5px; margin-bottom:10px; border: 2px solid; color: ${levantamiento.cat_color}" src="../apidev/${firstMedia.fileName}" />
                        </div>
                      </div>
                    `;

                    if (multimediaArray.length > 1) {
                      popuphtml += `
                      <span class="flex items-center justify-center bg-gray-900 bg-opacity-50 text-white cursor-pointer" onclick="slideToRight();">
                        <svg xmlns="http://www.w3.org/2000/svg" class="fill-current" height="48" width="48">
                          <path d="M18.75 36 16.6 33.85 26.5 23.95 16.6 14.05 18.75 11.9 30.8 23.95Z"/>
                        </svg>
                      </span>
                    `;
                    }
                  } else {
                    popuphtml += `
                      <video id="videoPopup" class="w-full" controls src="../apidev/${firstMedia.fileName}"></video>
                    `;
                  }

                  popuphtml += `
                  </div>
                `;

                  popuphtml += `
                  <div class="flex w-full items-center justify-center my-2">
                    <button class="bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center text-xs rounded-lg text-gray-100 tracking-wide" type="button" onclick="openMultimediaModal();">Ver en tamaño completo</button>
                  </div>
                `;
                }
              }

              popuphtml += `
                </div>
                <div class="flex justify-between items-center">
                  <div class="flex flex-col">
                    <span style='color: #363f43; font-size: 14px'>
                      ${levantamiento.nombre_usuario} ${levantamiento.apellido_usuario}
                    </span>
                    <span style='font-size: 12px; color:#9d9d9d;'>
                      ${TDate}
                    </span>
                  </div>
                  <div>
                    <button class="bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center text-base rounded-lg text-gray-100 tracking-wide" type="button" onclick="openFichaModal();">Ver ficha</button>
                    <button class="bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center text-base rounded-lg text-gray-100 tracking-wide" type="button" onclick="openShared();">Compartir</button>
                  </div>
                </div>`;

              markerLevantamiento.bindPopup(popuphtml, {
                maxWidth: "500px",
              });

              this.markerCluster.addLayer(markerLevantamiento);

              switch (levantamiento.cat_principal) {
                case "Patrimonio material":
                  this.globalCountMaterial += 1;
                  break;
                case "Patrimonio inmaterial":
                  this.globalCountInmaterial += 1;
                  break;
                case "Patrimonio natural":
                  this.globalCountNatural += 1;
                  break;
                case "Ficha de proyecto":
                  this.globalCountBiocultural += 1;
                  break;
              }
              this.globalcountTotal += 1;
            }
          });

          this.map.on("zoomend", function () {
            //// removed console log
            //let that=this;
            that.markerCluster.refreshClusters();
            /*                for (var i = 0; i < clustersWebservices.length; i++) {
                    if (map.hasLayer(clustersWebservices[i].markerClusterWebservice)) {
                        clustersWebservices[i].markerClusterWebservice.refreshClusters()
                    }
                } */
          });
        })
        .catch((error) => {
          // removed console log
          /*           if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          } */
        });

      // zoomer();
    },
    createClusterIcon: function (cluster) {
      let that = this;
      //// removed console log
      /*         var markers = cluster.getAllChildMarkers();
        var n = markers.length;
        var className;
        var size;
        if (n < 100) {
          className = 'clustersmall';
          size = 30;
        } else if (n < 200) {
          className = 'clustermedium';
          size = 45;
        } else {
          className = 'clusterbig';
          size = 60;
        }

        var clusterhtml = '<div align="center" style="white-space: nowrap;"> \
                            <center>\
                              <canvas align="center" width="'+size+'" height="'+size+'" style="opacity:0.9;"></canvas> \
                            </center> \
                            <div class="clusterTextPosition"> \
                              <span class="clusterText">'+markers.length.toString()+'</span> \
                            </div> \
                          </div>'

        var myIcon = new L.DivIcon({
          html: clusterhtml,
          className: className,
          iconSize: new L.Point(size, size)
        });

        return myIcon; */

      var Childs = cluster.getAllChildMarkers();
      var childCount = cluster.getChildCount();
      var Deteriorado = 0,
        Vulnerable = 0,
        Conservado = 0;
      var material = 0,
        inmaterial = 0,
        natural = 0,
        biocultural = 0;
      var counter = 0;

      for (let A = 0; A < Childs.length; A++) {
        switch (Childs[A].options.info.cat_principal) {
          case "Patrimonio material":
            material += 1;
            break;
          case "Patrimonio inmaterial":
            inmaterial += 1;
            break;
          case "Patrimonio natural":
            natural += 1;
            break;
          case "Ficha de proyecto":
            biocultural += 1;
            break;
        }

        /*           if(Childs[A].options.info.cat_principal.indexOf("material") != -1){
            material+=1;
          }if(Childs[A].options.info.cat_principal.indexOf("inmaterial") != -1){
            inmaterial+=1;
          }if(Childs[A].options.info.cat_principal.indexOf("natural") != -1){
            natural+=1;
          }else{ //biocultural
            biocultural+=1;
          } */
      }

      var Size = 40;
      var c = " marker-cluster-";
      if (childCount < 10) {
        c += "small";
        Size = 50;
      } else if (childCount < 100) {
        c += "medium";
        Size = 60;
      } else {
        c += "large";
        Size = 80;
      }

      var rID = this.getRandomNumber(1111, 9999);
      // var myIcon = new L.DivIcon({ html: '<div style="white-space: nowrap;  text-shadow: -2px 0 white, 0 2px white, 2px 0 white, 0 -2px white;"><center><canvas id="myChart_'+rID+'" width="'+Size+'" height="'+Size+'" style="opacity:0.6;"></canvas><br><font style="color:#009000; font-size:15px;"><b>'+Conservado+'</b></font> + <font style="color:#ffc018; font-size:15px;"><b>'+Vulnerable+'</b></font> + <font style="color:#F00000; font-size:15px;"><b>'+Deteriorado+'</b></font> = (<font style="font-size: 15px;"><b>'+ childCount +'</b></font>)</center></div>', className: 'marker-cluster' + c, iconSize: new L.Point(Size, Size) });
      //var myIcon = new L.DivIcon({ html: '<div style="white-space: nowrap;  text-shadow: -2px 0 white, 0 2px white, 2px 0 white, 0 -2px white;"><center><canvas id="myChart_'+rID+'" width="'+Size+'" height="'+Size+'" style="opacity:0.6;"></canvas><br><font style="color:#009000; font-size:15px;"><b>'+Conservado+'</b></font> + <font style="color:#ffc018; font-size:15px;"><b>'+Vulnerable+'</b></font> + <font style="color:#F00000; font-size:15px;"><b>'+Deteriorado+'</b></font> = (<font style="font-size: 15px;"><b>'+ childCount +'</b></font>)</center></div>', className: 'marker-cluster' + c, iconSize: new L.Point(Size, Size) });
      //var clusterhtml = '<div style="white-space: nowrap;  text-shadow: -2px 0 white, 0 2px white, 2px 0 white, 0 -2px white;"><center><canvas id="myChart_'+rID+'" width="'+Size+'" height="'+Size+'" style="opacity:0.6;"></canvas><br><font style="color:#009000; font-size:15px;"><b>'+Conservado+'</b></font> + <font style="color:#ffc018; font-size:15px;"><b>'+Vulnerable+'</b></font> + <font style="color:#F00000; font-size:15px;"><b>'+Deteriorado+'</b></font> = (<font style="font-size: 15px;"><b>'+ childCount +'</b></font>)</center></div>'

      let clusterhtml = `
        <div style="white-space: nowrap; text-shadow: -2px 0 white, 0 2px white, 2px 0 white, 0 -2px white;">
          <canvas id="myChart_${rID}" width="${Size}" height="${Size}"></canvas>
          <div class="flex items-center justify-center">
          </div>
          <div>
            <span style="font-size: 15px;" class="font-bold">${childCount}</span>
          </div>
        </div>
      `;

      // let clusterhtml = `
      //   <div style="white-space: nowrap; text-shadow: -2px 0 white, 0 2px white, 2px 0 white, 0 -2px white;">
      //     <canvas id="myChart_${rID}" width="${Size}" height="${Size}"></canvas>
      //     <div class="flex items-center justify-center">
      //       <span style="color: #ed7d31; font-size: 15px;">${material}</span>
      //       <span style="font-size: 15px;" class="font-bold px-1">/</span>
      //       <span style="color: #5a9ad7; font-size: 15px;">${inmaterial}</span>
      //       <span style="font-size: 15px;" class="font-bold px-1">/</span>
      //       <span style="color: #70ac48; font-size: 15px;">${biocultural}</span>
      //     </div>
      //     <div>
      //       <span style="font-size: 15px;" class="font-bold">(${childCount})</span>
      //     </div>
      //   </div>
      // `;

      /*         var clusterhtml = '<div align="center" style="white-space: nowrap;"> \
                            <center>\
                              <canvas align="center" id="myChart_'+rID+'" width="'+Size+'" height="'+Size+'" style="opacity:1;"></canvas> \
                            </center> \
                            <div class="clusterTextPosition"> \
                              <span class="clusterText">'+childCount.toString()+'</span> \
                            </div>' */

      var myIcon = new L.DivIcon({
        html: clusterhtml,
        //className: 'marker-cluster' + c,
        className: "sentiments",
        iconSize: new L.Point(Size, Size),
      });

      //// removed console log

      var dataCounters = [
        (material * 100) / childCount,
        (inmaterial * 100) / childCount,
        (natural * 100) / childCount,
        (biocultural * 100) / childCount,
      ];
      //var dataBackgroudColors =['rgba(255, 99, 132, 0.2)','rgba(255, 206, 86, 0.2)','rgba(75, 192, 192, 0.2)','rgba(255, 159, 64, 0.2)'];
      var dataBackgroudColors = ["#ed7d31", "#5a9ad7", "#ffc000", "#70ac48"];
      var dataLabels = [
        "Patrimonio material",
        "Patrimonio inmaterial",
        "Patrimonio natural",
        "Ficha de proyecto",
      ];

      setTimeout(function () {
        //// removed console log
        if (document.getElementById("myChart_" + rID) != undefined) {
          var data = {
            datasets: [
              {
                data: dataCounters,
                backgroundColor: dataBackgroudColors,
              },
            ],
            // These labels appear in the legend and in the tooltips when hovering different arcs
            labels: dataLabels,
          };

          var myChartCluster = document
            .getElementById("myChart_" + rID)
            .getContext("2d");
          if (myPieChart === undefined) {
            //// removed console log
            //// removed console log
            var myPieChart = new Chart(myChartCluster, {
              type: "pie",
              data: data,
              options: {
                animation: {
                  animateRotate: true,
                  animateScale: false,
                  duration: 300, //milisegundos
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  enabled: false,
                  mode: "dataset",
                  custom: function (tooltipModel) {
                    // `this` will be the overall tooltip
                    let position = this._chart.canvas.getBoundingClientRect();
                    //toolTipFormat(tooltipModel,position);
                  },
                },
              },
            });
          } else {
            // removed console log
            // removed console log
          }
        }
      }, 500);

      return myIcon;
    },

    // Generación de números aleatorios
    getRandomNumber: function (min, max) {
      return Math.random() * (max - min) + min;
    },
    // Formateo de números con ceros a la izquierda
    pad: function (a, b) {
      return (1e15 + a + "").slice(-b);
    },

    openMarkerPopUp: function (e) {
      //// removed console log
      // removed console log
      // removed console log
    },

    openShared: function () {
      // removed console log
      this.showShared = true;
    },
    openFichaModal: function () {
      // removed console log
      this.showFichaModal = true;
      /*       this.markerLayer.clearLayers();
      this.showLevantamientoModal = false; */
    },
    closeFichaModal: function () {
      // removed console log
      this.showFichaModal = false;
      /*       this.markerLayer.clearLayers();
      this.showLevantamientoModal = false; */
    },
    getComplaints: function () {
      axios
        .post("../apidev/visitors/complaintList", {}, this.config)
        .then((response) => {
          let array_complaints_open_first = [];
          let array_complaints_close_first = [];
          let array_complaints_process_first = [];

          let array_complaints_open_second = [];
          let array_complaints_close_second = [];
          let array_complaints_process_second = [];

          let array_complaints_open_third = [];
          let array_complaints_close_third = [];
          let array_complaints_process_third = [];

          let array_complaints_open_fourth = [];
          let array_complaints_close_fourth = [];
          let array_complaints_process_fourth = [];
          this.complaintsList = response.data;

          this.complaintsList.categories.forEach((complaint) => {
            if (complaint.lon != null && complaint.lat != null) {
              let point = turf.point([complaint.lon, complaint.lat]);

              this.polygonLimit.forEach((poly) => {
                let polygon = turf.multiPolygon(poly.geometry);
                let intersection = turf.inside(point, polygon);

                if (intersection) {
                  let complaint_info = {
                    type: "Feature",
                    properties: {
                      status: complaint.status,
                      text: complaint.text,
                      url: complaint.url,
                      file_type: complaint.file_type,
                      position: complaint.position,
                      data: complaint.date,
                      category_id: complaint.category_id,
                    },
                    geometry: {
                      type: "Point",
                      coordinates: [complaint.lon, complaint.lat],
                    },
                  };

                  switch (poly.id) {
                    case "First":
                      switch (complaint.status) {
                        case "no atendida":
                          array_complaints_open_first.push(complaint_info);
                          break;
                        case "en proceso":
                          array_complaints_close_first.push(complaint_info);
                          break;
                        case "atendida":
                          array_complaints_process_first.push(complaint_info);
                          break;
                        default:
                          break;
                      }
                      break;
                    case "Second":
                      switch (complaint.status) {
                        case "no atendida":
                          array_complaints_open_second.push(complaint_info);
                          break;
                        case "en proceso":
                          array_complaints_close_second.push(complaint_info);
                          break;
                        case "atendida":
                          array_complaints_process_second.push(complaint_info);
                          break;
                        default:
                          break;
                      }
                      break;
                    case "Third":
                      switch (complaint.status) {
                        case "no atendida":
                          array_complaints_open_third.push(complaint_info);
                          break;
                        case "en proceso":
                          array_complaints_close_third.push(complaint_info);
                          break;
                        case "atendida":
                          array_complaints_process_third.push(complaint_info);
                          break;
                        default:
                          break;
                      }
                      break;
                    case "Fourth":
                      switch (complaint.status) {
                        case "no atendida":
                          array_complaints_open_fourth.push(complaint_info);
                          break;
                        case "en proceso":
                          array_complaints_close_fourth.push(complaint_info);
                          break;
                        case "atendida":
                          array_complaints_process_fourth.push(complaint_info);
                          break;
                        default:
                          break;
                      }
                      break;
                    default:
                      break;
                  }
                  this.latLngArray.push([complaint.lat, complaint.lon]);
                }
              });
            }
          });

          this.geojsonsPolygon[0].geojson = array_complaints_open_first;
          this.geojsonsPolygon[1].geojson = array_complaints_close_first;
          this.geojsonsPolygon[2].geojson = array_complaints_process_first;

          this.geojsonsPolygon[3].geojson = array_complaints_open_second;
          this.geojsonsPolygon[4].geojson = array_complaints_close_second;
          this.geojsonsPolygon[5].geojson = array_complaints_process_second;

          this.geojsonsPolygon[6].geojson = array_complaints_open_third;
          this.geojsonsPolygon[7].geojson = array_complaints_close_third;
          this.geojsonsPolygon[8].geojson = array_complaints_process_third;

          this.geojsonsPolygon[9].geojson = array_complaints_open_fourth;
          this.geojsonsPolygon[10].geojson = array_complaints_close_fourth;
          this.geojsonsPolygon[11].geojson = array_complaints_process_fourth;

          this.geojsons[0].total =
            array_complaints_open_first.length +
            array_complaints_open_second.length +
            array_complaints_open_third.length +
            array_complaints_open_fourth.length;
          this.geojsons[1].total =
            array_complaints_close_first.length +
            array_complaints_close_second.length +
            array_complaints_close_third.length +
            array_complaints_close_fourth.length;
          this.geojsons[2].total =
            array_complaints_process_first.length +
            array_complaints_process_second.length +
            array_complaints_process_third.length +
            array_complaints_process_fourth.length;
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    filterLevantamientos(filterType = null) {
      this.$root.$emit("showLoading");

      if (filterType == "byProject") {
        this.filterByType = false;
      }
      if (filterType == "byType") {
        this.filterByProject = false;
      }

      this.filteredLevantamientos = this.levantamientos.filter(
        (levantamiento) => {
          if (this.filterByProject && this.projectSelected !== null) {
            return (
              parseInt(levantamiento.id_proyecto) === this.projectSelected &&
              levantamiento.nombre
                .toLowerCase()
                .includes(this.searchValue.toLowerCase())
            );
          } else if (this.filterByType && this.typeSelected !== null) {
            return (
              parseInt(levantamiento.id_cat_principal) === this.typeSelected &&
              levantamiento.nombre
                .toLowerCase()
                .includes(this.searchValue.toLowerCase())
            );
          } else {
            return levantamiento.nombre
              .toLowerCase()
              .includes(this.searchValue.toLowerCase());
          }
        }
      );

      this.listGalleryMultimedia = [];
      this.filteredLevantamientos.forEach((levantamiento) => {
        if (levantamiento.media_array !== null) {
          let multimediaArray = JSON.parse(levantamiento.media_array);
          multimediaArray.forEach((multimedia) => {
            //if (multimediaArray.length > 0) {
            multimedia.nombre = levantamiento.nombre;
            multimedia.nombre_usuario = levantamiento.nombre_usuario;
            multimedia.apellido_usuario = levantamiento.apellido_usuario;
            var TDate = new Date(levantamiento.fecha_levantamiento);
            TDate =
              weekday[TDate.getDay()] +
              " " +
              TDate.getDate() +
              " de " +
              month[TDate.getMonth()] +
              " de " +
              TDate.getFullYear();
            multimedia.TDate = TDate;
            multimedia.id = levantamiento.id;
            multimedia.latitud = levantamiento.latitud;
            multimedia.longitud = levantamiento.longitud;
            this.listGalleryMultimedia.push(multimedia);
            //}
          });
        }
      });

      this.globalCountMaterial = 0;
      this.globalCountInmaterial = 0;
      this.globalCountNatural = 0;
      this.globalCountBiocultural = 0;
      this.globalcountTotal = 0;

      if (this.backupLayers === null) {
        let layers = this.markerCluster.getLayers();
        this.backupLayers = [...layers];

        let layersToKeep = [];
        layers.forEach((layer) => {
          this.filteredLevantamientos.forEach((levantamiento) => {
            if (levantamiento.id === layer.options.info.id) {
              layersToKeep.push(layer);
            }
          });
        });

        let layersToRemove = layers.filter(
          (layer) => !layersToKeep.includes(layer)
        );

        layersToRemove.forEach((layer) => {
          this.markerCluster.removeLayer(layer);
        });

        layersToKeep.forEach((layer) => {
          switch (layer.options.info.cat_principal) {
            case "Patrimonio material":
              this.globalCountMaterial += 1;
              break;
            case "Patrimonio inmaterial":
              this.globalCountInmaterial += 1;
              break;
            case "Patrimonio natural":
              this.globalCountNatural += 1;
              break;
            case "Ficha de proyecto":
              this.globalCountBiocultural += 1;
              break;
          }
          this.globalcountTotal += 1;
        });
      } else {
        let layers = [...this.backupLayers];

        let layersToKeep = [];
        layers.forEach((layer) => {
          this.filteredLevantamientos.forEach((levantamiento) => {
            if (levantamiento.id === layer.options.info.id) {
              layersToKeep.push(layer);
            }
          });
        });

        let layersToRemove = layers.filter(
          (layer) => !layersToKeep.includes(layer)
        );

        layersToRemove.forEach((layer) => {
          this.markerCluster.removeLayer(layer);
        });

        layersToKeep.forEach((layer) => {
          if (!this.markerCluster.hasLayer(layer)) {
            this.markerCluster.addLayer(layer);
          }

          switch (layer.options.info.cat_principal) {
            case "Patrimonio material":
              this.globalCountMaterial += 1;
              break;
            case "Patrimonio inmaterial":
              this.globalCountInmaterial += 1;
              break;
            case "Patrimonio natural":
              this.globalCountNatural += 1;
              break;
            case "Ficha de proyecto":
              this.globalCountBiocultural += 1;
              break;
          }
          this.globalcountTotal += 1;
        });
      }

      this.$root.$emit("hideLoading");
    },
    clearFilterLevantamientos() {
      this.searchValue = "";
      this.filterLevantamientos();
    },
    slideToLeft() {
      let multimediaArray = JSON.parse(
        this.selectedLevantamientoInfo.media_array
      );
      if (this.currentMediaIndex > 0) {
        this.currentMediaIndex -= 1;
      } else {
        this.currentMediaIndex = multimediaArray.length - 1;
      }
      let nextMedia = multimediaArray[this.currentMediaIndex];

      if (nextMedia.mimeType.includes("image")) {
        let image = document.getElementById("mediaPopup");
        image.src = `../apidev/${nextMedia.fileName}`;
      } else {
        let video = document.getElementById("videoPopup");
        video.src = `../apidev/${nextMedia.fileName}`;
      }
    },
    slideToRight() {
      let multimediaArray = JSON.parse(
        this.selectedLevantamientoInfo.media_array
      );
      if (this.currentMediaIndex < multimediaArray.length - 1) {
        this.currentMediaIndex += 1;
      } else {
        this.currentMediaIndex = 0;
      }
      let nextMedia = multimediaArray[this.currentMediaIndex];

      if (nextMedia.mimeType.includes("image")) {
        let image = document.getElementById("mediaPopup");
        image.src = `../apidev/${nextMedia.fileName}`;
      } else {
        let video = document.getElementById("videoPopup");
        video.src = `../apidev/${nextMedia.fileName}`;
      }
    },
    checkSearchResults() {
      if (this.levantamientos != null && this.levantamientos.length > 0) {
        if (this.projectSelected === null) {
          if (this.searchValue.trim() == "") {
            // // removed console log
            this.showInputNameToExport();
          } else {
            if (this.filteredLevantamientos.length > 0) {
              // // removed console log
              this.showInputNameToExport();
            } else {
              // // removed console log
              this.msgNoRecordsToExport = true;
            }
          }
        } else {
          if (this.searchValue.trim() == "") {
            if (this.filteredLevantamientos.length > 0) {
              // // removed console log
              this.showInputNameToExport();
            } else {
              // // removed console log
              this.msgNoRecordsToExport = true;
            }
          } else {
            if (this.filteredLevantamientos.length > 0) {
              // // removed console log
              this.showInputNameToExport();
            } else {
              // // removed console log
              this.msgNoRecordsToExport = true;
            }
          }
        }
      } else {
        // // removed console log
        this.msgUnapprovedRecords = true;
      }
    },

    showInputNameToExport() {
      this.askingForNameOfFile = true;
    },

    exportLevantamientos() {
      /*       /* removed console log */
      // removed console log
      // removed console log */
      const nameFileToExport = document
        .getElementById("nameFileToExport")
        .value.trim();
      const descriptionFileToExport = document
        .getElementById("descriptionFileToExport")
        .value.trim();
      const validForm = this.checkFormDownloads(
        nameFileToExport,
        descriptionFileToExport
      );
      const userIDRequester = localStorage.getItem("user_id");
      let arrIDLev = [];

      if (validForm) {
        this.$root.$emit("showLoading");

        this.askingForNameOfFile = false;

        if (
          this.filteredLevantamientos != null &&
          this.filteredLevantamientos.length > 0
        ) {
          this.filteredLevantamientos.forEach((lev, indexLev) => {
            // // removed console log
            arrIDLev.push(lev.id);
          });
        } else {
          this.levantamientos.forEach((lev, indexLev) => {
            // // removed console log
            arrIDLev.push(lev.id);
          });
        }

        axios
          .post(
            "../apidev/downloads/exportLevantamientos",
            {
              idLevantamiento: arrIDLev,
              nameFileToExport: nameFileToExport,
              descriptionFileToExport: descriptionFileToExport,
              userIDRequester: userIDRequester,
            },
            this.config
          )
          .then(() => {
            // // removed console log
            this.$root.$emit("hideLoading");
            this.showingSuccess = true;
          })
          .catch((error) => {
            // removed console log
            this.$root.$emit("hideLoading");
            this.showingError = true;
          });
      }
    },
    fetchProjects() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          "../apidev/projects/getAllProjectsList",
          {
            activos: true,
          },
          this.config
        )
        .then((response) => {
          this.projects = response.data.proyectos;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchTypes() {
      this.$root.$emit("showLoading");
      this.axios
        .get("../apidev/categories/catprinc/getMainCategories", {}, this.config)
        .then((response) => {
          //// removed console log
          this.types = response.data.categorias;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    checkFormDownloads: function (nameFile, descFile) {
      if (nameFile === "" || nameFile === null) {
        this.errors.namefile = true;
      } else {
        this.errors.namefile = false;
      }

      if (descFile === "" || descFile === null) {
        this.errors.descriptionfile = true;
      } else {
        this.errors.descriptionfile = false;
      }

      if (this.errors.namefile || this.errors.descriptionfile) {
        return false;
      }
      return true;
    },
    closeModalToDownloads() {
      if (this.errors.namefile) this.errors.namefile = false;
      if (this.errors.descriptionfile) this.errors.descriptionfile = false;

      this.askingForNameOfFile = false;
    },
    openMultimediaModal() {
      let multimediaArray = JSON.parse(
        this.selectedLevantamientoInfo.media_array
      );
      this.currentMultimedia = multimediaArray[this.currentMediaIndex];

      this.showingMultimedia = true;
    },

    showProjectDetailModal() {
      //// removed console log
      this.showProjectDetail = true;
      EventBus.$emit("showProjectDetail", {
        id_proyecto: this.projectSelected,
      });
    },
    getTopUsers() {
      this.axios
        .post(
          "../apidev/levantamientos/getTopUsersByLevantamientos",
          {},
          this.config
        )
        .then((response) => {
          this.topUsers = response.data.statistics;
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    defaultProfile: function (user) {
      user.profile_image =
        "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
    },
    zoomOnMap: function (multimedia) {
      this.map.flyTo(multimedia.coords, 15, { animate: true, duration: 2 });
      let marker = this.markerCluster
        .getLayers()
        .find((layer) => layer.options.info.id === multimedia.id);

      this.showingMultimediaGallery = false;

      if (this.map.hasLayer(marker)) {
        setTimeout(() => {
          marker.fire("click");
        }, 2000);
      } else {
        setTimeout(() => {
          this.markerCluster.zoomToShowLayer(marker);
        }, 2000);

        setTimeout(() => {
          marker.fire("click");
        }, 3000);
      }
    },
  },

  created() {
    let that = this;
    // removed console log
    window.openShared = this.openShared.bind(this);
    window.openFichaModal = this.openFichaModal.bind(this);
    window.slideToLeft = this.slideToLeft.bind(this);
    window.slideToRight = this.slideToRight.bind(this);
    window.openMultimediaModal = this.openMultimediaModal.bind(this);

    /*     this.$socket.$subscribe("cleaning", data => {
      that.geojsonVisitor = that.geojsonVisitor.filter(feature => {
        let device_id = data.visitors.filter(id => {
          return feature.properties.device_id == id;
        });

        return device_id.length == 0;
      });

      that.geojsonVisitor = JSON.parse(JSON.stringify(that.geojsonVisitor));

      that.geojsonAuthorities = that.geojsonAuthorities.filter(feature => {
        let device_id = data.authorities.filter(id => {
          return feature.properties.device_id == id;
        });

        return device_id.length == 0;
      });

      that.geojsonAuthorities = JSON.parse(
        JSON.stringify(that.geojsonAuthorities)
      );
    }); */

    /*     this.$socket.$subscribe("position", data => {
      if (data.user_type === "visitor") {
        let getUser = that.geojsonVisitor.filter(feature => {
          return feature.properties.user == data.user_info.email;
        });

        if (getUser.length > 0) {
          let newCoordinates = [data.coordinates.lat, data.coordinates.lon];
          let oldCoordinates = [
            getUser[0].geometry.coordinates[1],
            getUser[0].geometry.coordinates[0]
          ];
          let distance = L.GeometryUtil.distance(
            this.map,
            newCoordinates,
            oldCoordinates
          );
          if (distance > 5) {
            getUser[0].geometry.coordinates = [
              data.coordinates.lon,
              data.coordinates.lat
            ];
          }
          //that.geojsonVisitor = JSON.parse(JSON.stringify(that.geojsonVisitor))
        } else {
          const new_icon = {
            type: "Feature",
            properties: {
              user: data.user_info.email,
              name: data.user_info.name,
              last_name: data.user_info.last_name,
              phone_number: data.user_info.phone_number,
              device_id: data.user_info.device_id,
              sex: data.user_info.sex,
              age: data.user_info.age,
              nivel_estudios: data.user_info.nivel_estudios,
              profile_image: data.user_info.profile_image
            },
            geometry: {
              type: "Point",
              coordinates: [data.coordinates.lon, data.coordinates.lat]
            }
          };

          that.geojsonVisitor.push(new_icon);
          that.geojsonVisitor = JSON.parse(JSON.stringify(that.geojsonVisitor));
        }
      } else {
        let getUser = that.geojsonAuthorities.filter(feature => {
          return feature.properties.user == data.user_info.email;
        });

        if (getUser.length > 0) {
          let newCoordinates = [data.coordinates.lat, data.coordinates.lon];
          let oldCoordinates = [
            getUser[0].geometry.coordinates[1],
            getUser[0].geometry.coordinates[0]
          ];
          let distance = L.GeometryUtil.distance(
            this.map,
            newCoordinates,
            oldCoordinates
          );
          if (distance > 5) {
            getUser[0].geometry.coordinates = [
              data.coordinates.lon,
              data.coordinates.lat
            ];
          }
          //that.geojsonAuthorities = JSON.parse(JSON.stringify(that.geojsonAuthorities))
        } else {
          const new_icon = {
            type: "Feature",
            properties: {
              user: data.user_info.email,
              name: data.user_info.name,
              last_name: data.user_info.last_name,
              phone_number: data.user_info.phone_number,
              device_id: data.user_info.device_id,
              auth_id: data.user_info.auth_id,
              sex: data.user_info.sex,
              age: data.user_info.age,
              authority_category_id: data.user_info.category_id,
              authority_category_name: data.user_info.name_category,
              profile_image: data.user_info.profile_image
            },
            geometry: {
              type: "Point",
              coordinates: [data.coordinates.lon, data.coordinates.lat]
            }
          };

          that.geojsonAuthorities.push(new_icon);
          that.geojsonAuthorities = JSON.parse(
            JSON.stringify(that.geojsonAuthorities)
          );
        }
      }
    }); */
  },
  computed: {
    styleGeojsonChapp() {
      return () => {
        return {
          color: "#cb2833",
          fill: false,
        };
      };
    },
    options() {
      return {
        pointToLayer: function (feature, latlng) {
          let color = "";
          let fillColor = "";

          switch (feature.properties.status) {
            case "no atendida":
              color = "#000";
              fillColor = "#cb2833";
              break;
            case "en proceso":
              color = "#000";
              fillColor = "#ffc200";
              break;
            case "Cerradas":
            case "atendida":
              color = "#000";
              fillColor = "#898d8d";
              break;
            default:
              color = "#000";
              fillColor = "#cb2833";
              break;
          }

          return L.circleMarker(latlng, {
            radius: 8,
            fillColor: fillColor,
            color: color,
            weight: 1,
            opacity: 1,
            fillOpacity: 0.8,
          });
        },
      };
    },
    optionsVisitor() {
      return {
        pointToLayer: function (feature, latlng) {
          var icon = new L.Icon({
            iconUrl: "../apidev/img/visit-marker.png",
            iconSize: [41, 41],
            iconAnchor: [41, 41],
            popupAnchor: [-20, -45],
            shadowSize: [41, 41],
            prefix: "icon",
          });

          return L.marker(latlng, {
            icon: icon,
          }).bindPopup(
            `
            <div class="flex flex-col">
              <span class="text-gray-700 text-sm font-semibold">Sexo: <span class="font-normal">${
                feature.properties.sex === "H" ? "Hombre" : "Mujer"
              }</span></span>
              <span class="text-gray-700 text-sm font-semibold">Edad: <span class="font-normal">${
                feature.properties.age
              }</span></span>
              <span class="text-gray-700 text-sm font-semibold">Nivel de estudios: <span class="font-normal">${
                feature.properties.nivel_estudios
              }</span></span>
            </div>
            `
          );
        },
      };
    },
    optionsAuthorities() {
      return {
        pointToLayer: function (feature, latlng) {
          var icon = new L.Icon({
            iconUrl: "../apidev/img/authority-marker.png",
            iconSize: [41, 41],
            iconAnchor: [41, 41],
            popupAnchor: [-20, -45],
            shadowSize: [41, 41],
            prefix: "icon",
          });

          return L.marker(latlng, {
            icon: icon,
          }).bindPopup(
            `
            <div class="flex flex-col">
              <span class="text-gray-900 text-sm font-bold tracking-wide">${
                feature.properties.name
              } ${feature.properties.last_name}</span>
              <span class="text-gray-700 text-sm font-semibold">ID: <span class="font-normal">${
                feature.properties.auth_id
              }</span></span>
              <span class="text-gray-700 text-sm font-semibold">Tel.: <span class="font-normal">${
                feature.properties.phone_number
              }</span></span>
              <span class="text-gray-700 text-sm font-semibold">Sexo: <span class="font-normal">${
                feature.properties.sex === "H" ? "Hombre" : "Mujer"
              }</span></span>
              <span class="text-gray-700 text-sm font-semibold">Edad: <span class="font-normal">${
                feature.properties.age
              }</span></span>
              <span class="text-gray-700 text-sm font-semibold">Categoría: <span class="font-normal">${
                feature.properties.authority_category_name
              }</span></span>
            </div>
            `
          );
        },
      };
    },
  },
};

let zoomer = function () {
  // removed console log
  //let el=document.querySelector('#img-zoomer-box');
  let el = document.querySelector("#mediaPopup");
  //// removed console log
  el.addEventListener(
    "mousemove",
    function (e) {
      // // removed console log
      let original = document.querySelector("#mediaPopup"); //#img-1
      //// removed console log
      let magnified = document.querySelector("#img-2");
      let style = magnified.style;
      let x = e.pageX - this.offsetLeft;
      let y = e.pageY - this.offsetTop;
      let imgWidth = original.offsetWidth;
      let imgHeight = original.offsetHeight;
      let xperc = (x / imgWidth) * 100;
      let yperc = (y / imgHeight) * 100;

      /*     /* removed console log */
    // removed console log
    // removed console log */

      var rect = e.target.getBoundingClientRect();
      var newx = e.clientX - rect.left; //x position within the element.
      var newy = e.clientY - rect.top; //y position within the element.
      //// removed console log

      //lets user scroll past right edge of image
      if (x > 0.01 * imgWidth) {
        xperc += 0.15 * xperc;
      }

      //lets user scroll past bottom edge of image
      if (y >= 0.01 * imgHeight) {
        yperc += 0.15 * yperc;
      }

      let newPercentx = (newx * 100) / imgWidth;
      let newPercentY = (newy * 100) / imgHeight;

      style.backgroundImage = "url('" + original.src + "')";
      style.backgroundPositionX = newPercentx + "%";
      style.backgroundPositionY = newPercentY + "%";
      /*     style.backgroundPositionX = (xperc - 9) + '%';
    style.backgroundPositionY = (yperc - 9) + '%'; */

      //// removed console log

      style.left = x - 180 + "px";
      style.top = y - 180 + "px";
    },
    false
  );

  el.addEventListener(
    "mouseenter",
    function (e) {
      //// removed console log
      let magnified = document.querySelector("#img-2");
      let style = magnified.style;
      style.opacity = 1;
      style.display = "block";
    },
    false
  );

  el.addEventListener(
    "mouseleave",
    function (e) {
      //// removed console log
      let magnified = document.querySelector("#img-2");
      let style = magnified.style;
      style.display = "none";
      style.opacity = 0;
    },
    false
  );
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* .leaflet-marker-label {
  width: auto !important;
  height: auto !important;
}

.leaflet-marker-iconlabel {
  background: #fff;
  border-radius: 7px;
  -moz-box-shadow: 0 3px 10px #888;
  -webkit-box-shadow: 0 3px 14px #999;
  box-shadow: 0 3px 10px #888;
  display: block;
  font: 11px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
  padding: 4px 6px;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  white-space: nowrap;
} */

/*Tamaño de clusters de acuerdo al numero de pines */
/* .clustersmall {
  border-radius: 20px;
  width: 20px;
  height: 20px;
  margin-left: 5px;
  margin-top: 5px;
  padding-top: 7px;
  background-clip: padding-box;
  background-color: rgba(181, 226, 140, 1);
  text-align: center;
  font: 12px "Helvetica Neue", Arial, Helvetica, sans-serif;
  z-index: -999 !important;
}

.clustermedium {
  z-index: -999 !important;
  border-radius: 30px;
  width: 40px;
  height: 40px;
  margin-left: 5px;
  margin-top: 5px;
  background-clip: padding-box;
  background-color: rgba(241, 211, 87, 1);
  text-align: center;
  padding-top: 13px;
  box-sizing: border-box;
  font: 12px "Helvetica Neue", Arial, Helvetica, sans-serif;
}

.clusterbig {
  z-index: -999 !important;
  border-radius: 30px;
  width: 60px;
  height: 60px;
  margin-left: 5px;
  margin-top: 5px;
  background-clip: padding-box;
  background-color: rgba(253, 156, 115, 1);
  text-align: center;
  padding-top: 20px;
  box-sizing: border-box;
  font: 12px "Helvetica Neue", Arial, Helvetica, sans-serif;
} */

.clusterTextPosition {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.clusterText {
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  font-weight: bolder;
  font-size: 130%;
  color: white;
}

.sentiments {
  z-index: -999 !important;
}

.CImg {
  border-radius: 10px;
  background-color: #ffffff;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  /* box-shadow: 0 0 8px rgba(0, 0, 0, 0.8);
  -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.8);
  -moz-box-shadow: 0 0 8px rgba(0, 0, 0, 0.8); */
  -webkit-transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
  transition: all 0.25s ease-in-out;
}

.Crop {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

hr {
  border-top-width: 3px;
  border-color: #b792f7;
}

.leaflet-popup-content {
  width: auto !important;
}
/* .marker-cluster-small {
	background-color: rgba(181, 226, 140, 0.0);
	}
.marker-cluster-small div {
	background-color: rgba(110, 204, 57, 0.0);
	}

.marker-cluster-medium {
	background-color: rgba(241, 211, 87, 0.0);
	}
.marker-cluster-medium div {
	background-color: rgba(240, 194, 12, 0.0);
	}

.marker-cluster-large {
	background-color: rgba(253, 156, 115, 0.0);
	}
.marker-cluster-large div {
	background-color: rgba(241, 128, 23, 0.0);
	} */

.button {
  border: none;
  color: white;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  cursor: pointer;
}

.button1 {
  background-color: #4caf50;
  color: black;
  border: 2px solid #4caf50;
}

.button1:hover {
  background-color: #136115;
  border: 2px solid #136115;
  color: white;
}

.button2 {
  background-color: white;
  color: black;
  border: 2px solid #008cba;
}

.button2:hover {
  background-color: #008cba;
  color: white;
}

.selectMun {
  width: 25em;
  max-width: 30em;
  /* margin: 1em auto; */
}

/****** */

#img-zoomer-box {
  /* width: 500px; */
  /* height: auto; */
  position: relative;
  margin-top: 10px;
}

#img-1 {
  width: 100%;
  height: auto;
}

#img-zoomer-box:hover,
#img-zoomer-box:active {
  cursor: zoom-in;
  display: block;
}

#img-zoomer-box:hover #img-2,
#img-zoomer-box:active #img-2 {
  opacity: 1;
}
#img-2 {
  /* border: 1px solid rgb(0, 0, 0); */
  width: 340px;
  height: 340px;
  background: url("https://bit.ly/2mgDw0y") no-repeat #fff;
  box-shadow: 0 5px 10px -2px rgba(0, 0, 0, 0.3);
  pointer-events: none;
  position: absolute;
  opacity: 0;
  border: 4px solid whitesmoke;
  z-index: 99999999999;
  border-radius: 10%;
  /* display: block; */
  display: none;
  transition: opacity 0.2s;
}
</style>
